import { AgGrid, Grid } from "@jsq/ds/core";
import { useAgGridDefaults } from "~/pages/UserAndRoles/utils/gridConfig";
import { useWorkspaceRolesTable } from "./hooks";

export type WorkspaceRow = {
  role: string;
  assignedUsers: number;
};

export type WorkspaceRolesTableProps = {
  onGridReady: (event: AgGrid.GridReadyEvent<WorkspaceRow>) => void;
  rowData: WorkspaceRow[];
  onRowClicked: (event: AgGrid.RowClickedEvent<WorkspaceRow>) => void;
  onFilterChanged: (event: AgGrid.FilterChangedEvent) => void;
};

export const WorkspaceRolesTable = ({
  onGridReady,
  rowData,
  onRowClicked,
  onFilterChanged,
}: WorkspaceRolesTableProps) => {
  const { columnDefs } = useWorkspaceRolesTable();
  const { gridOptions } = useAgGridDefaults({
    overrides: {
      paginationPageSize: 50,
      overlayNoRowsTemplate: "No roles found",
      suppressRowClickSelection: true,
      suppressCellFocus: true,
      statusBar: {
        statusPanels: [{ statusPanel: "agTotalRowCountComponent" }],
      },
    },
  });
  return (
    <Grid
      onGridReady={onGridReady}
      columnDefs={columnDefs}
      gridOptions={gridOptions}
      rowData={rowData}
      onRowClicked={onRowClicked}
      onFilterChanged={onFilterChanged}
    />
  );
};
